
<form
    [formGroup]="editClientForm"
    (ngSubmit)="submitHandler()"
  >
  <mat-form-field class="item">
    <input matInput placeholder="Client Name" formControlName="name" />
  </mat-form-field>

  <mat-form-field class="item">
    <input matInput placeholder="Kennitala / Id Númer" formControlName="idnumber" />
  </mat-form-field>

  <mat-form-field class="item">
    <input matInput placeholder="Heimilisfang" formControlName="address1" />
  </mat-form-field>

  <mat-form-field class="item">
    <input matInput placeholder="Póstnúmer" formControlName="address2" />
  </mat-form-field>

  <mat-form-field class="item">
    <input matInput placeholder="Bæjarfélag" formControlName="address3" />
  </mat-form-field>

  <mat-form-field class="item">
    <input matInput placeholder="Land" formControlName="country" />
  </mat-form-field>

  <div formArrayName="contacts">
    <div
      *ngFor="let contact of contactForms.controls; let i = index"
      [formGroupName]="i"
      class="contacts-container"
    >
      <mat-form-field class="contacts-item">
        <input
          matInput
          placeholder="Nafn"
          formControlName="contactname"
        />
      </mat-form-field>

      <mat-form-field class="contacts-item">
        <input
          matInput
          placeholder="Netfang"
          formControlName="contactemail"
        />
      </mat-form-field>

      <mat-form-field class="contacts-item">
        <input
          matInput
          placeholder="Sími"
          formControlName="contactphone"
        />
      </mat-form-field>
      <button
        mat-raised-button
        color="warn"
        (click)="deleteContact(i)"
        class="contact-button"
      >
      <i class="material-icons">
          delete
          </i>Eyða
      </button>
    </div>
  </div>
<div class="button-container">
  <button
    mat-raised-button
    color="accent"
    type="button"
    (click)="addContact()"
  >
    Nýr Contact aðili
  </button>
  <button
  class="submit-button"
    mat-raised-button
    color="primary"
    type="submit"
    [disabled]="editClientForm.invalid"
  >
    Staðfesta
  </button></div>
</form>

